import React from 'react';

import {
  Navigate,
  Route,
  Routes
} from 'react-router-dom';

import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Inventory from './pages/Inventory';
import Products from './pages/Products';
import Customers from './pages/Customers';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';

function App() {

  return (
    <Routes>

      <Route
        path="/login"
        element={<Login />}
      />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >

        <Route
          index
          element={<Navigate to="/dashboard" replace />}
        />

        <Route
          path="dashboard"
          element={<Dashboard />}
        />

        <Route
          path="orders"
          element={<Orders />}
        />

        <Route
          path="orders/:id"
          element={<OrderDetail />}
        />

        <Route
          path="inventory"
          element={<Inventory />}
        />

        <Route
          path="products"
          element={<Products />}
        />

        <Route
          path="customers"
          element={<Customers />}
        />

        <Route
          path="notifications"
          element={<Notifications />}
        />

        <Route
          path="settings"
          element={<Settings />}
        />

      </Route>

    </Routes>
  );
}

export default App;